import { FaFacebook, FaInstagram, FaWhatsapp, FaYoutube } from "react-icons/fa";
import { BsTwitterX } from "react-icons/bs";
import { Link } from "react-router-dom";
import "./SocialIcon.css"; // We'll create this CSS file

const SocialIcons = () => {
  return (
    <div className="social-icons-container">
      <Link
        to="https://youtube.com"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon youtube"
      >
        <FaYoutube />
      </Link>
      
      <Link
        to="https://facebook.com"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon facebook"
      >
        <FaFacebook />
      </Link>

      <Link
        to="https://"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon instagram"
      >
        <FaInstagram />
      </Link>

      <Link
        to="https://twitter.com"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon twitter"
      >
        <BsTwitterX />
      </Link>

      <Link
        to="https://wa.me/"
        target="_blank"
        rel="noopener noreferrer"
        className="social-icon whatsapp"
      >
        <FaWhatsapp />
      </Link>
    </div>
  );
};

export default SocialIcons;